// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#welcome-section {
    background-color: #f0f0f0;
    padding: 4em 1.5em;
}

#welcome-section h3 {
    line-height: 3rem;
    font-size: clamp(20px, 2vw, 24px);
}

#welcome-section h1 {
    line-height: 3rem;
    font-size: 48px;
}

#welcome-section-services {
    background-color: #f0f0f0;
    padding: 4em 1.5em;
}

#welcome-section-services h3 {
    line-height: 3rem;
    font-size: clamp(20px, 2vw, 24px);
}

#welcome-section-services h1 {
    line-height: 3rem;
    font-size: 48px;
}

.column {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
}

.welcome-body {
    /* width: 50%;
    margin: 0 auto 4rem; */
    text-align: center;
}

.welcome-body-services {
    /* width: 50%;
    margin: 0 auto 4rem; */
    text-align: center;
}

#logo-emblem {
    /* padding: 0 2rem; */
    width: 70%;
    margin: 0 auto;
}

#logo-emblem-services {
    width: 100%;
    padding: 0 1rem;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 2rem auto;
}
.logo-emblem-link {
    margin: .5rem 0;
}

#logo-emblem-services img {
    border-radius: .5rem;
    width: 100%;
}

#logo-emblem > img {
    width: 100%;
    border-radius: .5rem;
}

.welcome-section-button-container {
    width: 100%;
    text-align: center;
    height: fit-content;
    margin: 2rem 0;
}

@media screen and (min-width: 768px) {
    #welcome-section {
        padding: 7em 3.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #welcome-section-services {
        padding: 7em 3.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .welcome-body {
        width: 50%;
        margin: 0 0 0 2rem;
        text-align: left;
    }

    .welcome-body-services {
        width: 100%;
        max-width: 1000px;
        padding: 0 2rem;
        margin: 0 0 0 2rem;
    }

    #logo-emblem-services {
        flex-wrap: nowrap;
        justify-content: center;
    }

    .logo-emblem-link {
        width: 30%;
        max-width: 400px;
        margin: 0 1rem;
    }

    #logo-emblem {
        width: 30rem;
        margin: 0 2rem 0 0;
    }

    .welcome-section-button-container {
        text-align: left;
    }
}`, "",{"version":3,"sources":["webpack://./components/WelcomeSection/WelcomeSection.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;0BACsB;IACtB,kBAAkB;AACtB;;AAEA;IACI;0BACsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["#welcome-section {\n    background-color: #f0f0f0;\n    padding: 4em 1.5em;\n}\n\n#welcome-section h3 {\n    line-height: 3rem;\n    font-size: clamp(20px, 2vw, 24px);\n}\n\n#welcome-section h1 {\n    line-height: 3rem;\n    font-size: 48px;\n}\n\n#welcome-section-services {\n    background-color: #f0f0f0;\n    padding: 4em 1.5em;\n}\n\n#welcome-section-services h3 {\n    line-height: 3rem;\n    font-size: clamp(20px, 2vw, 24px);\n}\n\n#welcome-section-services h1 {\n    line-height: 3rem;\n    font-size: 48px;\n}\n\n.column {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n.welcome-body {\n    /* width: 50%;\n    margin: 0 auto 4rem; */\n    text-align: center;\n}\n\n.welcome-body-services {\n    /* width: 50%;\n    margin: 0 auto 4rem; */\n    text-align: center;\n}\n\n#logo-emblem {\n    /* padding: 0 2rem; */\n    width: 70%;\n    margin: 0 auto;\n}\n\n#logo-emblem-services {\n    width: 100%;\n    padding: 0 1rem;\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    margin: 2rem auto;\n}\n.logo-emblem-link {\n    margin: .5rem 0;\n}\n\n#logo-emblem-services img {\n    border-radius: .5rem;\n    width: 100%;\n}\n\n#logo-emblem > img {\n    width: 100%;\n    border-radius: .5rem;\n}\n\n.welcome-section-button-container {\n    width: 100%;\n    text-align: center;\n    height: fit-content;\n    margin: 2rem 0;\n}\n\n@media screen and (min-width: 768px) {\n    #welcome-section {\n        padding: 7em 3.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    #welcome-section-services {\n        padding: 7em 3.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-wrap: wrap;\n    }\n\n    .welcome-body {\n        width: 50%;\n        margin: 0 0 0 2rem;\n        text-align: left;\n    }\n\n    .welcome-body-services {\n        width: 100%;\n        max-width: 1000px;\n        padding: 0 2rem;\n        margin: 0 0 0 2rem;\n    }\n\n    #logo-emblem-services {\n        flex-wrap: nowrap;\n        justify-content: center;\n    }\n\n    .logo-emblem-link {\n        width: 30%;\n        max-width: 400px;\n        margin: 0 1rem;\n    }\n\n    #logo-emblem {\n        width: 30rem;\n        margin: 0 2rem 0 0;\n    }\n\n    .welcome-section-button-container {\n        text-align: left;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
